import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `CambioEstadoVerraco/imprimirCambioEstado`, method: 'POST', body: values, token: token})
}